<div
  poziScrollFade
  class="tile-grid-container"
  [ngClass]="'tile-grid-' + appStyle()"
  [style.grid-template-areas]="gridTemplateAreas()"
  [style.grid-template-columns]="gridTemplateColumns()"
  [style.grid-template-rows]="gridTemplateRows()"
>
  @for (key of keysWithTemplate(); track key) {
    @if (isMapTile(grid().tiles[key])) {
      <pozi-google-maps
        [style.grid-area]="key"
        [input]="googleMapsInputMap().get(key)!"
        [isBackToOverviewButtonEnabled]="false"
        [mapOptionsOverride]="nonInteractiveGoogleMapsOptions"
      ></pozi-google-maps>
    } @else if (grid().tiles[key].hasOwnProperty('calendarChartItems')) {
      <pozi-calendar-chart
        [isInTileRow]="true"
        [data]="getCalendarChart(key)"
        [itemsWithEqualSize]="hasCalendarAndTimeline()"
        [style.grid-area]="key"
      ></pozi-calendar-chart>
    } @else if (
      grid().tiles[key].hasOwnProperty('timelines') ||
      grid().tiles[key].hasOwnProperty('amChart')
    ) {
      <pozi-timeline-chart-v2
        [style.grid-area]="key"
        [data]="getTimelineChart(key)"
      ></pozi-timeline-chart-v2>
    } @else if (hasTileV2()) {
      <pozi-tile-v2
        [tile]="getTileV2(key)"
        [limitExtension]="limitExtension()"
        [clickableTile]="clickableTile()"
        [style.grid-area]="key"
      ></pozi-tile-v2>
    } @else {
      <pozi-tile [tile]="getTile(key)" [style.grid-area]="key"></pozi-tile>
    }
  }

  @for (area of grid().template.flat(); track $index) {
    @if (!keysWithTemplate().includes(area)) {
      <div class="placeholder-tile"></div>
    }
  }
</div>
